// Edited item of the Send Schedule D/E Link window (CD-5433). ClientId only scopes the contact picker and
// ScheduleEDLinkSent only drives the resend confirmation - neither is sent.
export default class OpportunityScheduleEdLinkItem {
  constructor(item) {
    this.OpportunityId = item?.OpportunityId ?? null;
    this.ClientId = item?.ClientId ?? null;
    this.ContactId = item?.ContactId ?? '';
    this.ScheduleEDLinkSent = item?.ScheduleEDLinkSent ?? false;
  }
}
